module.exports = __webpack_public_path__ + "img/open-data-error.20239ee8.gif";